var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeWork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.233,
    height: 26.373,
    viewBox: "0 0 32.233 26.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_work_FILL0_wght400_GRAD0_opsz48",
    d: "M26.065,13.948h2.2v-2.2h-2.2Zm0,6.264h2.2v-2.2h-2.2Zm0,6.227h2.2v-2.2h-2.2Zm-2.051,5.934v-2.2h8.022V8.2H17.567v4.1l-2.2-1.538V8.2a2.189,2.189,0,0,1,2.2-2.2H32.036a2.189,2.189,0,0,1,2.2,2.2V30.175a2.189,2.189,0,0,1-2.2,2.2ZM24.014,18.2ZM2,31.274V19.223a2.3,2.3,0,0,1,.238-1.007,1.935,1.935,0,0,1,.678-.788L10.644,11.9a2.241,2.241,0,0,1,2.564,0L20.9,17.428a1.935,1.935,0,0,1,.678.788,2.3,2.3,0,0,1,.238,1.007V31.274a1.065,1.065,0,0,1-1.1,1.1h-6.85V25.01H9.985v7.362H3.1a1.065,1.065,0,0,1-1.1-1.1Zm2.2-1.1h3.59V22.813h8.278v7.362h3.553V19.223l-7.692-5.531L4.2,19.223Zm11.868,0V22.813H7.787v0h8.278Z",
    transform: "translate(-2 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWork);
export default __webpack_public_path__ + "static/media/home-work.fa60eb8d065c5ceeb1e120c98c5dcfac.svg";
export { ForwardRef as ReactComponent };